module.exports = __webpack_public_path__ + "static/media/silkycloud-logo.bc175ee4.jpg";